module.exports = __webpack_public_path__ + "img/costa-rica.62626541.svg";